import { Component, OnInit, Input } from '@angular/core';
import { AssistancePrice } from '../../../models/assistance-price';

@Component({
    selector: 'app-assistance-bill-info',
    templateUrl: './assistance-bill-info.component.html',
    styleUrls: ['./assistance-bill-info.component.css'],
    standalone: false
})
export class AssistanceBillInfoComponent implements OnInit {
  @Input()
    set setAssistancePrice(assistancePrice: AssistancePrice) {
    this.assistancePrice = assistancePrice;
  }

  assistancePrice: AssistancePrice;

  ngOnInit() {
    this.assistancePrice = null;
  }
}
